<template>
    <v-container fluid>
        <v-col cols="12">
            <!--Datatable-->
            <SalesList :search_enabled="true"></SalesList>
        </v-col>
    </v-container>
</template>

<script>
    import SalesList from '../../components/SalesList.vue'

    export default {
        components: {
            SalesList
        }
    }
</script>